import React from 'react';
import {t} from 'ttag';
import { ROLES } from "./utils/user/user-utils";
import {AuthorizationGuard} from "./guards";
import SidebarLink from './layout/main-layout/SidebarLink';
import SidebarDropDownLink from "./layout/main-layout/SidebarDropDownLink";
import {useStore} from "./store/valtio";
import {
  ConnectingAirports,
  Dashboard,
  Flight,
  HowToReg,
  Settings,
  SpeakerNotesOutlined,
  RequestQuote,
  Payments,
  FactCheck,
  CardMembership, SmartToyOutlined,
  Article
} from '@mui/icons-material';
import ReceiptIcon from '@mui/icons-material/Receipt';
import {SPP_ENDPOINT} from './config/settings';

export const SidebarMenu = () => {
  const {app} = useStore();

  return (
  <>
      <SidebarLink path={'/'} text={t`Dashboard`} icon={<Dashboard/>} exact />

      <AuthorizationGuard userHasSomeOf={[ROLES.CCS_ADMIN, ROLES.CCS_SUPERVISOR, ROLES.CCS_AGENT]}>
        <SidebarLink path={'/refunds'} text={t`Refunds doc`} icon={<RequestQuote/>} />
      </AuthorizationGuard>

      <AuthorizationGuard userHasSomeOf={[ROLES.CCS_ADMIN, ROLES.CCS_SUPERVISOR, ROLES.CCS_AGENT, ROLES.CCS_FINANCE]}>
        <SidebarLink path={'/invoice/search'} text={t`Invoice System`} icon={<ReceiptIcon/>} />
      </AuthorizationGuard>

      <AuthorizationGuard userHasSomeOf={[ROLES.CCS_ADMIN, ROLES.CCS_SUPERVISOR, ROLES.CCS_AGENT, ROLES.CCS_LOYALTY]}>
        <SidebarLink path={'/activities'} text={t`Activities`} icon={<FactCheck/>} />
      </AuthorizationGuard>

      <AuthorizationGuard userHasSomeOf={[ROLES.CCS_ADMIN, ROLES.CCS_SUPERVISOR, ROLES.CCS_AGENT]}>
        <SidebarLink path={`${SPP_ENDPOINT}`} text={t`Payments`} icon={<Payments/>} external={true}/>
      </AuthorizationGuard>

      {/*<AuthorizationGuard userHasSomeOf={[ROLES.CCS_ADMIN, ROLES.CCS_SUPERVISOR, ROLES.CCS_AGENT]}>
        <SidebarLink path={'/receipt-request'} text={t`Receipt Request`} icon={<Receipt/>} />
      </AuthorizationGuard>*/}

      <AuthorizationGuard userHasSomeOf={[ROLES.CCS_ADMIN, ROLES.CCS_SUPERVISOR, ROLES.CCS_AGENT]}>
        <SidebarLink path={'/claims'} text={t`Check Claims`} icon={<SpeakerNotesOutlined/>} />
      </AuthorizationGuard>

      <AuthorizationGuard userHasSomeOf={[ROLES.CCS_ADMIN, ROLES.CCS_DECLARATIONS_ALL]}>
        <SidebarLink path={'/declarations'} text={t`Declarations`} icon={<Article/>} />
      </AuthorizationGuard>

      <AuthorizationGuard userHasSomeOf={[ROLES.CCS_ADMIN, ROLES.CCS_PHM_AI]}>
        <SidebarLink path={'/chatbot'} text={t`PHM Chatbot`} icon={<SmartToyOutlined/>} />
      </AuthorizationGuard>

      <AuthorizationGuard userHasSomeOf={[ROLES.CCS_ADMIN, ROLES.CCS_SUPERVISOR, ROLES.CCS_AGENT]}>
        <SidebarLink path={'/transport-facilities'} text={t`Industry Discount`} icon={<Flight style={{rotate: '90deg'}}/>} />
      </AuthorizationGuard>

      <AuthorizationGuard userHasSomeOf={[ROLES.CCS_ADMIN, ROLES.CCS_RESIDENT_VALIDATOR, ROLES.CCS_AGENT, ROLES.CCS_SUPERVISOR]}>
        <SidebarLink path={'/resident-validator'} text={t`Resident Validator`} icon={<HowToReg/>} exact/>
      </AuthorizationGuard>

      <AuthorizationGuard userHasSomeOf={[ROLES.CCS_ADMIN, ROLES.CCS_SUPERVISOR, ROLES.CCS_AGENT, ROLES.CCS_LOYALTY, ROLES.CCS_RESIDENT_VALIDATOR]}>
        <SidebarLink external openInNewTab path={'https://webapp.cartaointerjovem.com/webservice/check_valid.php'} text={t`Cartão Interjovem`} icon={<CardMembership style={{fontSize: '30px'}}/>} />
      </AuthorizationGuard>

      <AuthorizationGuard userHasSomeOf={[ROLES.CCS_ADMIN, ROLES.CCS_RESIDENT_VALIDATOR, ROLES.CCS_AGENT, ROLES.CCS_SUPERVISOR, ROLES.CCS_LOYALTY]}>
          <SidebarDropDownLink
              path={'/links'}
              text={app.sideBarOpen ? t`Cash & Miles` : 'C&M'}
              icon={<ConnectingAirports style={{fontSize: '30px'}}/>}
              subLinks={[
                  {path: 'https://cashmiles.sata.pt', text: `Cash & Miles APP`, externalLink: true},
                  {path: '/cash_and_miles.xlsx', text: `Cash & Miles Ratio`, externalLink: true},
              ]}
          />
      </AuthorizationGuard>

      <AuthorizationGuard userHasSomeOf={[ROLES.CCS_ADMIN]}>
        <SidebarLink path={'/settings/employees'} text={t`Settings`} icon={<Settings/>}/>
      </AuthorizationGuard>

  </>
)};

export default SidebarMenu;
